import {
  EuiFlexGroup,
  EuiFlexItem,
  EuiPopover,
  htmlIdGenerator,
} from "@inscopix/ideas-eui";
import { useState } from "react";
import { useProjectTablesTableContext } from "components/ProjectTablesTable/provider/ProjectTablesTableProvider";
import { ButtonEmptyPermissioned } from "components/ButtonEmptyPermissioned/ButtonEmptyPermissioned";

/**
 * Component that renders a button for creating a new data table or analysis
 * table
 */
export const ButtonCreateTable = () => {
  const [isPopoverOpen, setIsPopoverOpen] = useState(false);

  const openCreateDataTableModal = useProjectTablesTableContext(
    (s) => s.openCreateDataTableModal,
  );
  const openCreateAnalysisTableModal = useProjectTablesTableContext(
    (s) => s.openCreateAnalysisTableModal,
  );
  const openCreateFolderModal = useProjectTablesTableContext(
    (s) => s.openCreateFolderModal,
  );

  return (
    <>
      <EuiPopover
        id={htmlIdGenerator()()}
        button={
          <ButtonEmptyPermissioned
            requiredPermission="edit"
            aria-label="Create table or folder"
            iconType="plus"
            onClick={() => setIsPopoverOpen((isOpen) => !isOpen)}
          >
            Add
          </ButtonEmptyPermissioned>
        }
        isOpen={isPopoverOpen}
        closePopover={() => setIsPopoverOpen(false)}
        anchorPosition="upCenter"
        css={{ textAlign: "center" }}
      >
        <EuiFlexGroup
          direction="column"
          gutterSize="none"
          alignItems="flexStart"
        >
          <EuiFlexItem>
            <ButtonEmptyPermissioned
              requiredPermission="edit"
              iconType="tableDensityNormal"
              onClick={() => {
                openCreateDataTableModal();
                setIsPopoverOpen(false);
              }}
            >
              Data table
            </ButtonEmptyPermissioned>
          </EuiFlexItem>
          <EuiFlexItem>
            <ButtonEmptyPermissioned
              requiredPermission="edit"
              iconType="indexMapping"
              onClick={() => {
                openCreateAnalysisTableModal();
                setIsPopoverOpen(false);
              }}
            >
              Analysis table
            </ButtonEmptyPermissioned>
          </EuiFlexItem>
          <EuiFlexItem>
            <ButtonEmptyPermissioned
              requiredPermission="edit"
              iconType="folderOpen"
              onClick={() => {
                openCreateFolderModal();
                setIsPopoverOpen(false);
              }}
            >
              Folder
            </ButtonEmptyPermissioned>
          </EuiFlexItem>
        </EuiFlexGroup>
      </EuiPopover>
    </>
  );
};
